import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const TaskFlag = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M0,0 L1.9983898,0 L1.99365363,1.46504723 C4.64906293,0.684507926 7.2107219,0.885300038 9.67863054,2.06742356 L10,2.2271788 C13.1769438,3.86418587 16.5102771,3.86418587 20,2.2271788 L16.0459491,8.9948824 L20,13.2362919 C16.5029301,14.7300758 13.2715463,14.7798686 10.3058486,13.3856703 L10,13.2362919 C7.52078328,11.979779 4.85357988,11.7449648 1.9983898,12.5318494 L1.9983898,20 L0,20 L0,0 Z M9.65108695,3.72904898 L9.31293256,3.56057233 C7.19003713,2.46669248 5.02407212,2.21997591 2.7432872,2.81363839 L1.99365363,3.173 L1.99365363,11.112 L2.09350487,11.0857626 C5.1740538,10.2367696 7.61557911,10.4503678 10.3388132,11.7324893 L10.6781088,11.8983201 C12.6553921,12.9004438 14.7647469,13.1509747 17.0564401,12.6324248 L17.325,12.567 L14.1879303,9.20158722 L16.756,4.804 L16.6471915,4.82294641 C14.2532953,5.17863455 11.909725,4.81600529 9.65108695,3.72904898 Z"
				id="taskFlag"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

TaskFlag.propTypes = {
	color: PropTypes.string,
};

export default TaskFlag;
